import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "faq" */ './index'),
  loading: () => null,
})
